import React from 'react';
import { costFormater, Text } from '@common-fe/common-fe';

import { ContributionStatus } from './EnrollmentDetailsContributions.types';
import EnrollmentDetailsContributionsFrequencies from './EnrollmentDetailsContributionsFrequencies';
import EnrollmentDetailsContributionsWrapper from './EnrollmentDetailsContributionsWrapper';
import EnrollmentDetailsItem from './EnrollmentDetailsItem';
import { useGetEmployeeContributionInfoQuery } from './queries';

interface Props {
  employeeId: string;
  isAccountClosed?: boolean;
}
const EnrollmentDetailsContributionsContainer: React.FC<Props> = ({ isAccountClosed, employeeId }) => {
  const { data, isNotFound } = useGetEmployeeContributionInfoQuery(employeeId);
  if (isAccountClosed) {
    return (
      <EnrollmentDetailsContributionsWrapper isStandalone>
        <Text size="large" weight={700}>
          Individual contributions cannot be setup for closed accounts
        </Text>
      </EnrollmentDetailsContributionsWrapper>
    );
  }
  if (
    data?.status === ContributionStatus.EXPIRED ||
    data?.status === ContributionStatus.CANCELLED ||
    isNotFound
  ) {
    return (
      <EnrollmentDetailsContributionsWrapper isStandalone>
        <EnrollmentDetailsItem
          key="enrollment-contribution_recurring-contributions"
          testId="enrollment-contribution_recurring-contributions"
          title="Recurring contributions"
          color="textDisabled"
        >
          Not Set
        </EnrollmentDetailsItem>
      </EnrollmentDetailsContributionsWrapper>
    );
  }
  return (
    <EnrollmentDetailsContributionsWrapper>
      <EnrollmentDetailsItem
        key="enrollment-contribution_recurring-contributions"
        testId="enrollment-contribution_recurring-contributions"
        title="Recurring contributions"
        color={data?.status === ContributionStatus.ACTIVE ? 'success' : 'textBody'}
      >
        {data?.status === ContributionStatus.ACTIVE ? 'Active' : 'Paused'}
      </EnrollmentDetailsItem>
      <EnrollmentDetailsItem
        key="enrollment-contribution_frequency"
        testId="enrollment-contribution_frequency"
        title="Frequency"
      >
        <EnrollmentDetailsContributionsFrequencies
          frequency={data.frequency}
          recurringDay={data.recurringDay}
        />
      </EnrollmentDetailsItem>
      <EnrollmentDetailsItem
        key="enrollment-contribution_amount"
        testId="enrollment-contribution_amount"
        title="Amount"
      >
        {costFormater(data?.amount, {
          isPrecision: true,
        })}
      </EnrollmentDetailsItem>
      {data?.status !== ContributionStatus.PAUSED && (
        <EnrollmentDetailsItem
          key="enrollment-contribution_next-scheduled-contribution"
          testId="enrollment-contribution_next-scheduled-contribution"
          title="Next scheduled contribution"
        >
          {data?.nextScheduledDate}
        </EnrollmentDetailsItem>
      )}

      <EnrollmentDetailsItem
        key="enrollment-contribution_date-range"
        testId="enrollment-contribution_date-range"
        title="Date range"
      >
        {data?.dateRange}
      </EnrollmentDetailsItem>
    </EnrollmentDetailsContributionsWrapper>
  );
};

export default EnrollmentDetailsContributionsContainer;
